export interface PageModel {
  icon?: string;
  title?: string;
  url?: string;
  caret?: string;
  submenu?: any;
  hide?: any;
  state?: string;
  selected?: boolean;
  sort?: number;
}

export const pageMenus: PageModel[] = [
  {
    icon: 'insert_chart_outlined',
    title: 'Dashboard',
    url: '/home',

    sort: 1
  }, 
  {
    icon: 'point_of_sale',
    title: 'NAV.SAVE_DAY',
    url: '',
    caret: 'true',
    sort: 2,
    submenu: [
      {
        subicon: 'fa fa-circle',
        url: '/work/sale',
        title: 'NAV.SALE',
      },
      {
        subicon: 'fa fa-circle',
        url: '/work/often-sale',
        title: 'สินค้าขายบ่อย',
      },
      {
        subicon: 'fa fa-circle',
        url: '/work/return',
        title: 'NAV.RETURN'
      },
      {
        subicon: 'fa fa-circle',
        url: '/work/claim',
        title: 'เคลมสินค้า'
      },
      {
        subicon: 'fa fa-circle',
        url: '/work/withdraw-return',
        title: 'ยืม - คืน'
      },
    ]
  },
  {
    icon: 'dvr',
    title: 'NAV.REPORT',
    url: '',
    caret: 'true',
    sort: 3,
    submenu: [
      {
        subicon: 'fa fa-circle',
        url: 'report/report-pl',
        title: 'NAV.REPORT_PL'
      },
      {
        subicon: 'fa fa-circle',
        url: 'report/report-sale-group-product',
        title: 'NAV.REPORT_SALE_CATEGORY'
      },
      {
        subicon: 'fa fa-circle',
        url: 'report/report-sale-detail',
        title: 'NAV.REPORT_SALE_DETAITL'
      },
      {
        subicon: 'fa fa-circle',
        url: 'report/report-sale',
        title: 'NAV.REPORT_SALE'
      },
      {
        subicon: 'fa fa-circle',
        url: 'report/report-sale-perday',
        title: 'NAV.REPORT_SPD'
      },
      {
        subicon: 'fa fa-circle',
        url: 'report/report-sale-month',
        title: 'NAV.REPORT_SPM'
      },
      {
        subicon: 'fa fa-circle',
        url: 'report/report-sale-user',
        title: 'NAV.REPORT_USER_SALE'
      },
      {
        subicon: 'fa fa-circle',
        url: 'report/report-sale-member',
        title: 'NAV.REPORT_SPMEM'
      },
      {
        subicon: 'fa fa-circle',
        url: 'report/report-stock',
        title: 'NAV.REPORT_STOCK'
      },
      {
        subicon: 'fa fa-circle',
        url: 'report/report-withdraw',
        title: 'รายงานการยืมอุปกรณ์'
      },
      {
        subicon: 'fa fa-circle',
        url: 'report/report-sale-debtor',
        title: 'NAV.REPORT_AR'
      },
      {
        subicon: 'fa fa-circle',
        url: 'report/report-sale-creditor',
        title: 'NAV.REPORT_CDT'
      },
      {
        subicon: 'fa fa-circle',
        url: 'report/report-stock-movement',
        title: 'NAV.REPORT_STOCK_HIS'
      },
      {
        subicon: 'fa fa-circle',
        url: 'report/report-channel-sale',
        title: 'NAV.REPORT_SPCH'
      },
      {
        subicon: 'fa fa-circle',
        url: 'report/report-sale-payment',
        title: 'NAV.REPORT_SPPAY'
      }
    ]
  },
  {
    icon: 'archive',
    title: 'NAV.STOCK',
    url: '',
    caret: 'true',
    sort: 4,
    submenu: [
      {
        subicon: 'fa fa-circle',
        url: '/stock/po',
        title: 'NAV.PO'
      },
      {
        subicon: 'fa fa-circle',
        url: 'stock/import',
        title: 'NAV.IMPORT_ST'
      },
      {
        subicon: 'fa fa-circle',
        url: 'stock/adjust',
        title: 'NAV.ADJUST_ST'
      },
      {
        subicon: 'fa fa-circle',
        url: 'stock/reques',
        title: 'NAV.REQUES_ST'
      },
      {
        subicon: 'fa fa-circle',
        url: 'stock/receive',
        title: 'NAV.RESIVE_ST'
      },
      {
        subicon: 'fa fa-circle',
        url: 'stock/transfer',
        title: 'NAV.TRANSFER_ST'
      },
    ]
  },
  {
    icon: 'style',
    title: 'NAV.PROMOTION',
    url: '',
    sort: 5,
    caret: 'true',
    submenu: [
      {
        subicon: 'fa fa-circle',
        url: '/promotion/setscoremember',
        title: 'NAV.SET_MEMBER_POINT'
      },
      {
        subicon: 'fa fa-circle',
        url: '/promotion/group',
        title: 'NAV.PRICE_GROUP'
      },
      {
        subicon: 'fa fa-circle',
        url: '/promotion/coupon',
        title: 'NAV.COUPON'
      },
      {
        subicon: 'fa fa-circle',
        url: '/promotion/bonus',
        title: 'NAV.FREE_PROMOTION'
      },
      {
        subicon: 'fa fa-circle',
        url: '/promotion/promotion-set',
        title: 'NAV.PROMOTION_SET'
      },
      {
        subicon: 'fa fa-circle',
        url: '/promotion/erp',
        title: 'ผลิตสินค้า'
      }
    ]
  },
  {
    icon: 'laptop_mac',
    title: 'NAV.ACCOUNTING',
    url: '',
    caret: 'true',
    sort: 6,
    submenu: [
      {
        subicon: 'fa fa-circle',
        url: '/account/acc-structure',
        title: 'ผังบัญชี'
      },
      {
        subicon: 'fa fa-circle',
        url: '/account/acc-invest',
        title: 'เงินลงทุน'
      },
      {
        subicon: 'fa fa-circle',
        url: '/account/acc-log',
        title: 'สมุดบัญชีรายวันทั่วไป'
      },
      {
        subicon: 'fa fa-circle',
        url: '/account/billsale',
        title: 'NAV.MANAGE_BILL'
      },
      {
        subicon: 'fa fa-circle',
        url: '/account/quotation',
        title: 'NAV.QTT'
      },
      {
        subicon: 'fa fa-circle',
        url: '/account/paytype',
        title: 'NAV.PAYMENT_TYPE'
      },
      {
        subicon: 'fa fa-circle',
        url: '/account/payment',
        title: 'NAV.PAYMENT'
      },
      {
        subicon: 'fa fa-circle',
        url: '/account/memberscore',
        title: 'NAV.MEMBER_POINT'
      },
      {
        subicon: 'fa fa-circle',
        url: '/account/payroll',
        title: 'เงินเดือนพนักงาน'
      },
      {
        subicon: 'fa fa-circle',
        url: '/account/company-assets',
        title: 'NAV.COMPANY_ASSETS'
      },
    ]
  },
  {
    icon: 'settings',
    title: 'NAV.SETTING',
    url: '',
    caret: 'true',
    sort: 7,
    submenu: [
      {
        subicon: 'fa fa-circle',
        url: '/setting/organization',
        title: 'NAV.ST_COMPANY'
      },
      {
        subicon: 'fa fa-circle',
        url: '/setting/branch',
        title: 'NAV.ST_BRANCH'
      },
      {
        subicon: 'fa fa-circle',
        url: '/setting/chanelSale',
        title: 'NAV.ST_CHANELSALE'
      },
      {
        subicon: 'fa fa-circle',
        url: '/setting/payment',
        title: 'NAV.ST_CHANELPAYMENT'
      },
      {
        subicon: 'fa fa-circle',
        url: '/setting/productgroup',
        title: 'NAV.ST_PD_TYPE'
      },
      {
        subicon: 'fa fa-circle',
        url: '/setting/product',
        title: 'NAV.ST_PRODUCT'
      },
      {
        subicon: 'fa fa-circle',
        url: '/setting/pricepermembergroup',
        title: 'NAV.ST_PRICE'
      },
      {
        subicon: 'fa fa-circle',
        url: '/setting/supplier',
        title: 'ผู้จำหน่ายสินค้า'
      },
      {
        subicon: 'fa fa-circle',
        url: '/setting/membertype',
        title: 'NAV.MEMBER_PAGE.DIALOG.MEMBER_TYPE'
      },
      {
        subicon: 'fa fa-circle',
        url: '/work/member',
        title: 'NAV.MEMBER'
      },
      {
        subicon: 'fa fa-circle',
        url: '/setting/user',
        title: 'NAV.ST_USER'
      },
      {
        subicon: 'fa fa-circle',
        url: '/setting/moneyincash',
        title: 'เงินในลิ้นชัก'
      },
      {
        subicon: 'fa fa-circle',
        url: '/setting/pricetag',
        title: 'ป้ายราคาสินค้า'
      }
    ]
  },
  {
    icon: 'build',
    title: 'NAV.SYSTEM',
    url: '',
    caret: 'true',
    sort: 8,
    submenu: [
      {
        subicon: 'fa fa-circle',
        url: 'system/menu-for-use',
        title: 'NAV.SET_MENU_FOR_USE'
      },
      {
        subicon: 'fa fa-circle',
        url: '/system/bill-format',
        title: 'NAV.SET_RUNNING_BILL'
      },
      {
        subicon: 'fa fa-circle',
        url: 'system/set-print-bill',
        title: 'NAV.SET_PRINT_BILL'
      },
      {
        subicon: 'fa fa-circle',
        url: 'system/set-bill-and-less-qty',
        title: 'NAV.SET_BILL_AND_LESS_QTY'
      },
      {
        subicon: 'fa fa-circle',
        url: '/system/sale-setting',
        title: 'NAV.SALE_CONDITION'
      },
    ]
  },
  {
    icon: 'phone',
    title: 'ICommerce',
    url: '',
    caret: 'true',
    sort: 9,
    submenu: [
      {
        subicon: 'fa fa-circle',
        url: '/icommerce/Ordericommerce',
        title: 'Order'
      },
      {
        subicon: 'fa fa-circle',
        url: '/icommerce/Contacticommerce',
        title: 'ช่องทางการติดต่อ'
      },
      {
        subicon: 'fa fa-circle',
        url: '/icommerce/PromotionDiscountComponent',
        title: 'เพิ่มสินค้าลดราคา'
      },
      {
        subicon: 'fa fa-circle',
        url: '/icommerce/GropProductModule',
        title: 'นำสินค้าเข้าหมวดหมู่'
      },
      {
        subicon: 'fa fa-circle',
        url: '/icommerce/JposshopflashsaleModule',
        title: 'สินค้า Flash Sale'
      },
      {
        subicon: 'fa fa-circle',
        url: '/icommerce/ImagejposshopModule',
        title: 'เพิ่มรูปภาพสินค้า'
      },
      // {
      //   subicon: 'fa fa-circle',
      //   url: '/icommerce/Icommerce-chat',
      //   title: 'แชท'
      // },
    ]
  },
];

export const pageMenusSeller: PageModel[] = [
  {
    icon: 'point_of_sale',
    title: 'NAV.SAVE_DAY',
    url: '',
    caret: 'true',
    submenu: [
      {
        subicon: 'fa fa-circle',
        url: '/work/sale',
        title: 'NAV.SALE',

      },
      {
        subicon: 'fa fa-circle',
        url: '/work/return',
        title: 'NAV.RETURN'
      },
      // {
      //   'subicon': 'fa-shopping-cart',
      //   'url': '',
      //   'title': 'NAV.SALE'
      // },
    ]
  }
];
